import {CssBaseline} from "@mui/material"
import {ThemeProvider as MuiThemeProvider} from "@mui/material/styles"
import {ThemeProvider} from "@emotion/react"
import {ReactNode} from "react"

import {useLocale} from "../../src/useLocale"

import {createLocaleTheme, themeNewLandingPage} from "."

const AppThemeProvider = ({children}: {children: ReactNode}) => {
	const {isRTL} = useLocale()

	const theme = createLocaleTheme(isRTL ? "rtl" : "ltr")
	return (
		<MuiThemeProvider theme={theme}>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				{children}
			</ThemeProvider>
		</MuiThemeProvider>
	)
}

export const AppNewThemeProvider = ({children}: {children: ReactNode}) => {
	const {isRTL} = useLocale()

	const theme = createLocaleTheme(isRTL ? "rtl" : "ltr", themeNewLandingPage)
	return (
		<MuiThemeProvider theme={theme}>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				{children}
			</ThemeProvider>
		</MuiThemeProvider>
	)
}

export {AppThemeProvider}
